module.exports = __webpack_public_path__ + "img/okex_sign.6b3c0872.svg";